import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { cockpitChartInterface } from 'src/app/util/interfaces/cockpitRework/cockpitRework';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';
import { ChartData } from 'chart.js';

@Injectable({
	providedIn: 'root',
})
export class CockpitPageService {
	private getAvailableCiTypesUrl = environment.baseApiUrl + 'myasset/ciFilter';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getAvailablesCiTypes(): Observable<any> {
		const getAvailableCiTypesUrl = this.getAvailableCiTypesUrl;
		return this.http.get<any>(getAvailableCiTypesUrl, { headers: this.headers });
	}
}
